// strings, floats
export default (h, field, errorMessages, value, onInput, onBlur, onFocus, self) => {
  console.log('Switch Field')
  return h('v-switch',
    {
      class: field.attributes.class,
      props: {
        errorMessages: errorMessages,
        inputValue: value,
        ...field.attributes
      },

      on: {
        change: onInput,
        blur: onBlur
      }
    }
  )
}
